import { useDashboardSummary } from './lib/useDashboardSummary';
import React, { useState } from 'react';
import { Wallet, Maximize2 } from 'lucide-react';
import ContaPagarTotal from './ContaPagarTotal';

function StatBox({ title, icon: Icon, color, border, principal, secundario, saldoPagar, acrescimo, desconto, percentual, onExpand }) {
  return (
    <div className={`relative bg-[#161b22] border-l-4 ${border} px-5 py-3 rounded shadow-xl flex flex-col justify-between h-full transition-all hover:bg-[#1c222a]`}>
      <button
        onClick={onExpand}
        aria-label="Ver detalhes de pagamentos"
        className="absolute top-3 right-3 text-gray-600 hover:text-yellow-500 transition-colors z-20"
      >
        <Maximize2 size={18} />
      </button>

      <div className={`flex items-center gap-2 mb-3 ${color} font-black text-[10px] uppercase tracking-widest`}>
        <Icon size={14} /> <span>{title}</span>
      </div>

      <div className="flex justify-between items-end mb-3">
        <div>
          <p className="text-gray-500 text-[9px] font-bold uppercase mb-1 italic">A Pagar (Mês) R$</p>
          <p className="text-white font-mono text-2xl font-bold italic tracking-tighter">
            {Number(principal).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
          </p>
        </div>

        <div className="relative w-16 h-16 rotate-[-90deg]">
          <svg className="w-full h-full">
            <circle cx="32" cy="32" r="28" stroke="#0d1117" strokeWidth="4" fill="transparent" />
            <circle
              cx="32" cy="32" r="28" stroke="currentColor"
              className="text-green-500 shadow-[0_0_8px_#22c55e]"
              strokeWidth="4" fill="transparent"
              strokeDasharray={175.9}
              strokeDashoffset={175.9 - (175.9 * Math.min(100, Math.max(0, percentual))) / 100}
              strokeLinecap="round"
            />
          </svg>
          <div className="absolute inset-0 flex items-center justify-center rotate-90">
            <span className="text-yellow-500 font-mono text-xs font-black">{percentual.toFixed(2).replace('.', ',')}%</span>
          </div>
        </div>
      </div>
      <div className="flex justify-between items-end gap-3 mb-3">
        <div><p className="text-gray-500 text-[9px] font-bold uppercase italic">Acréscimo R$</p>
          <p className="text-green-400 font-mono text-lg font-bold italic tracking-tighter">           
            {Number(acrescimo).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
            </p>
        </div>
        <div><p className="text-gray-500 text-[9px] font-bold uppercase italic">Descontos R$</p>
          <p className="text-red-400 font-mono text-lg font-bold italic tracking-tighter">
            {Number(desconto).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
          </p>
        </div>
      </div>
      <div className="flex justify-between items-end gap-3">
        <div>
          <p className="text-gray-500 text-[9px] font-bold uppercase italic">Pago R$</p>
          <p className="text-green-400 font-mono text-lg font-bold italic tracking-tighter">
            {Number(secundario).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
            {/*{formatBRL(secundario)}*/}
          </p>
        </div>
        <div>
          <p className="text-gray-500 text-[9px] font-bold uppercase italic">Saldo a Pagar R$</p>
          <p className="text-red-400 font-mono text-lg font-bold italic tracking-tighter">
             {Number(saldoPagar).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
            {/*{formatBRL(saldoPagar)}*/}
          </p>
        </div>
      </div>

    </div>
  );
}


const formatBRL = value => Number(value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default function Conta({ empresa = '', refreshSignal = 0 } = {}) {


  const [isModalOpen, setIsModalOpen] = useState(false);

  const { data, loading, error } = useDashboardSummary('/api/dashboard/financeiro/ContaPagar', { empresa, refreshSignal });
  if (error) return <div role="alert" className="rounded border border-red-900 bg-[#161b22] p-4 text-xs text-red-300">{error}</div>;

  if (loading) return (
    <div className="bg-[#161b22] border-l-4 border-yellow-500 p-5 rounded animate-pulse h-[180px]">
      <div className="h-4 bg-gray-800 rounded w-1/2 mb-4"></div>
      <div className="h-8 bg-gray-800 rounded w-3/4"></div>
    </div>
  );

  const aPagar = data?.aPagarMes || 0;
  const valorQuitado = data?.quitadosMes || 0;
  const saldoPagar = data?.saldoEmAberto || 0;
  const percentual = aPagar > 0 ? (valorQuitado / aPagar) * 100 : 0;

  return (
    <>
      <StatBox
        title="FLUXO DE CAIXA: PAGAMENTOS"
        icon={Wallet}
        color="text-yellow-500"
        border="border-yellow-500"
        principal={aPagar}
        secundario={valorQuitado}
        percentual={percentual}
        saldoPagar={saldoPagar}
        acrescimo={data?.acrescimo || 0}
        desconto={data?.desconto || 0}
        onExpand={() => setIsModalOpen(true)}
      />

      {isModalOpen && (
        <ContaPagarTotal
          data={data}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </>
  );
}
